import { render } from "./ImageGalleryPopUp.vue?vue&type=template&id=1e41cbc5&scoped=true"
import script from "./ImageGalleryPopUp.vue?vue&type=script&lang=js"
export * from "./ImageGalleryPopUp.vue?vue&type=script&lang=js"

import "./ImageGalleryPopUp.vue?vue&type=style&index=0&id=1e41cbc5&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e41cbc5"]])

export default __exports__